/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import bedroom from "assets/images/Services/Accommodation/bedroom1.jpg";
import bathroom from "assets/images/Services/Accommodation/bathroom1.jpg";
import kitchen from "assets/images/Services/Accommodation/kitchen1.jpg";
import livingroom from "assets/images/Services/Accommodation/livingroom1.jpg";
import outdoor from "assets/images/Services/Accommodation/outdoor1.jpg";

const cleaningCategories = [
  {
    image: bedroom,
    name: "Bedrooms",
    position: { color: "info", label: "" },
    description: [
      "Changing and making beds with fresh linens",
      "Dusting and wiping down surfaces",
      "Vacuuming or mopping floors",
      "Emptying bins",
      "Arranging furniture neatly",
      "Cleaning mirrors and windows",
    ],
  },
  {
    image: bathroom,
    name: "Bathrooms",
    position: { color: "info", label: "" },
    description: [
      "Cleaning and disinfecting toilets, sinks, showers, and bathtubs",
      "Polishing mirrors and fixtures",
      "Restocking essentials (e.g., toilet paper, soap, towels if provided)",
      "Vacuuming or mopping floors",
      "Emptying bins",
      "Cleaning mirrors and windows",
    ],
  },
  {
    image: kitchen,
    name: "Kitchen or Pantry",
    position: { color: "info", label: "" },
    description: [
      "Cleaning countertops, sinks, and exterior surfaces of appliances",
      "Wiping down tables and chairs",
      "Emptying bins",
      "Vacuuming or mopping floors",
    ],
  },
  {
    image: livingroom,
    name: "Living and Common Areas",
    position: { color: "info", label: "" },
    description: [
      "Dusting and wiping down surfaces (e.g., coffee tables, shelves)",
      "Vacuuming or mopping floors",
      "Arranging furniture neatly",
      "Emptying bins",
    ],
  },
  {
    image: outdoor,
    name: "Outdoor Spaces",
    position: { color: "info", label: "" },
    description: [
      "Sweeping patios, balconies, or porches",
      "Cleaning outdoor furniture",
      "Wiping down windows and doors",
      "Emptying bins",
    ],
  },
];

function Accommodation_Section4() {
  return (
    <Container>
      <Grid container direction="column" alignItems="center" sx={{ mx: "auto" }} width="100%">
        <Grid item>
          <SubTitleContents
            title="What’s Included in Our Regular Accommodation Cleaning Services?"
            contents="We understand the importance of a pristine and inviting space for your guests. Here’s what you can expect from our regular accommodation cleaning services:"
          />
        </Grid>

        <Grid item mt={5} width="100%">
          <Grid container spacing={3}>
            {cleaningCategories.map((category, index) => (
              <Grid item xs={12} lg={6} key={index}>
                <MKBox mb={1} height="100%">
                  <CircularPhotoCard
                    image={category.image}
                    icon="check"
                    name={category.name}
                    position={category.position}
                    description={category.description}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Accommodation_Section4;
